



























































































import {Component, Watch, Mixins} from 'vue-property-decorator'
import {$, MixinUpload} from 'simpli-web-sdk'
import {UploadConfig} from '@/config/upload.config'
import Papa from 'papaparse'
import {FileObject} from 'image-compressor.js'
import * as Helper from '@/helpers'
import {AppConfig} from '@/config/app.config'
import PersistEmailAlertaNotaAtrasoRequest from '@/model/request/PersistEmailAlertaNotaAtrasoRequest'
import EmailAlertaNotaAtraso from '@/model/resource/EmailAlertaNotaAtraso'

const metaInfo = () => ({
  title: $.t('view.manage.alertDelayedNotasEmail.title'),
})

@Component({
  metaInfo,
})
export default class ManageAlertDelayedNotasEmailView extends Mixins(MixinUpload) {
  readonly UPLOAD_CONFIG = UploadConfig.buildDataPreset(1)

  selectedTransportador: EmailAlertaNotaAtraso | null = null

  list: EmailAlertaNotaAtraso[] = []
  listEmail: string[] | null = null

  get listWithNull() {
    return [new EmailAlertaNotaAtraso(), ...this.list]
  }

  async mounted() {
    await this.populate()
  }

  @Watch('selectedTransportador.cpfCnpj')
  async selectedTransportadorEvent(cpfCnpj: string | null) {
    if (cpfCnpj && this.selectedTransportador) {
      const {data} = await this.selectedTransportador.listEmailsByCpfCnpj()
      this.listEmail = data
    } else {
      this.listEmail = null
    }
  }

  async populate() {
    const {data} = await EmailAlertaNotaAtraso.listCpfCnpjAlertaNotaAtraso()
    this.list = data.map((cpfCnpj) => {
      const model = new EmailAlertaNotaAtraso()
      model.cpfCnpj = cpfCnpj
      return model
    })
  }

  @Watch('files') // upload
  async filesEvent(files: FileObject[]) {
    if (!files.length) return
    $.await.init('uploadCsv')

    const blueprint = AppConfig.csvBlueprint.emailAlertaNotaAtraso
    const data = await Helper.csvToNormalizedData(files[0].file, blueprint)

    const validateDocument = (item: string) => {
      if (item != null) {
        return item
      }
      $.await.done('uploadCsv')
      throw this.$snotify.error(this.$t('view.manage.alertDelayedNotasEmail.cnpfCnpjCannotBeNull'))
    }

    const request = new PersistEmailAlertaNotaAtrasoRequest()
    request.emails = data.map((item) => {
      const model = new EmailAlertaNotaAtraso()
      model.email = item.email
      model.cpfCnpj = validateDocument(item.cpfCnpj)
      return model
    })

    try {
      await request.persistEmailAlertaNotaAtraso()
    } finally {
      $.await.done('uploadCsv')
    }

    Helper.success('system.success.persist')

    await this.populate()
    this.selectedTransportador = null
  }

  async downloadCsv() {
    const {data} = await this.$await.run(() => EmailAlertaNotaAtraso.listEmailAlertaNotaAtraso(), 'downloadCsv')
    const list = data.map((item: EmailAlertaNotaAtraso) => ({
      'CPF / CNPJ - TRANSPORTADOR': Helper.cpfOrCnpj(item.cpfCnpj),
      'EMAIL - TRANSPORTADOR': item.email,
    }))
    const csv = Papa.unparse(list)
    Helper.createCsvFile('Emails Alerta Nota Em Atraso.csv', csv)
  }
}
